import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import colors from '../../../configuration/colors'
import MenuButton from '../../mini/Buttons/MenuButton'
import ProgressBar from '../../mini/ProgressBar'
import H5 from '../../typography/headers/H5'
import Caption4 from '../../typography/captions/Caption4'
import { cleanHexCode } from '../util'
import GradeElement from '../../mini/GradeElement'

const CourseHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
`

const CourseInfo = styled.div`
  align-items: center;
  align-content: center;
  display: flex;
  flex: ${props => (props.grow && '1' : '0')};
`

const CourseNameElement = styled.h3`
  color: ${props => props.color};
  font-family: Montserrat, sans-serif;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  margin-left: 10px;
  margin-right: 30px;
`

export const CourseHeader = ({
  activityCourse,
  academicYears,
  selectedAcademicYearId
}) => {
  const frameworkSubjects = useSelector(state => state.frameworksubjects.items)
  const frameworkSubjectName = frameworkSubjects.find(
    fs => fs.id === activityCourse.framework_subject_id
  ).name

  const gradeLevels = useSelector(state => state.gradelevels.items)
  const gradeLevel = gradeLevels.find(
    gl => gl.id === activityCourse.grade_level_id
  )

  return (
    <CourseHeaderContainer>
      <CourseInfo grow>
        <GradeElement
          name={gradeLevel.name}
          abbreviation={gradeLevel.abbreviation}
        />
        <CourseNameElement color={cleanHexCode(activityCourse.color)}>
          {activityCourse.name}
        </CourseNameElement>
      </CourseInfo>
      <CourseInfo grow>
        <H5 style={{ width: '45px', paddingRight: '30px' }}>
          {activityCourse.abbreviation}
        </H5>
        <H5>
          {frameworkSubjectName}
        </H5>
      </CourseInfo>
      <CourseInfo style={{ justifyContent: 'flex-end' }}>
        <H5>
          <span style={{ paddingRight: '10px' }}>
            {activityCourse.courses_count}
          </span>
          Journeys
        </H5>
        <ProgressBar
          progress={
            activityCourse.courses_count > 0
              ? (activityCourse.enrollment_ready_courses_count /
                  activityCourse.courses_count) *
                100
              : 0
          }
        />
        <MenuButton
          activityCourse={activityCourse}
          journeyQuantity={activityCourse.courses_count}
          academicYears={academicYears}
          selectedAcademicYearId={selectedAcademicYearId}
        />
      </CourseInfo>
    </CourseHeaderContainer>
  )
}

CourseHeader.propTypes = {
  activityCourse: PropTypes.object.isRequired,
  academicYears: PropTypes.array.isRequired,
  selectedAcademicYearId: PropTypes.number.isRequired
}

export default CourseHeader



// WEBPACK FOOTER //
// ./src/components/mycourses/Course/CourseHeader.js